import store from '@/store/index';
import { trackingRecord } from '@/utils/bridgeHelper';
import { deepmerge } from '@/utils/misc';
import Sentry from './sentry';

export const helpCenterTracking = (data: Partial<ITrackingData>) => {
  try {
    const uid = store.getState().user?.uid || '';

    const commonData = {
      id: 'help_centre',
      page: 'help_centre',
      data: {
        uid,
      },
    };
    trackingRecord(deepmerge(commonData, data) as ITrackingData);
  } catch (e) {
    e.name = 'HelpCenterTrackingError';
    Sentry.captureException(e);
  }
};
